import * as React from 'react';
import * as mui from '@mui/material';

interface StepperProps {
	activeStep: number;
	setActiveStep: (newStep: number) => any;
	formattedCartTotal: string;
}

export default function Stepepr(props: StepperProps) {
	const { activeStep, setActiveStep } = props;

	return (
		<mui.Stepper activeStep={activeStep - 1} alternativeLabel sx={{ py: 4, maxWidth: theme => theme.breakpoints.values.lg, m: '0 auto' }}>
			{['Il primo protagonista', 'I compagni di viaggio', `Procedi`].map((label, index) => (
				<mui.Step key={label} onClick={() => setActiveStep(index + 1)}>
					<mui.StepLabel sx={{ cursor: 'pointer' }}>{label}</mui.StepLabel>
				</mui.Step>
			))}
		</mui.Stepper>
	);
}
